module.exports = __webpack_public_path__ + "static/media/marketing-demo.be653a3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/marketing-demo.jpg
// module id = 399
// module chunks = 0